import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { STAGES, STAGE_LABEL } from "@/lib/meta";

let cache = null;
let pending = null;
const subs = new Set();

export function refreshStages() {
  pending = api.get("/meta/config").then(({ data }) => {
    cache = { stages: data.stages, labels: { ...STAGE_LABEL, ...data.stage_labels } };
    subs.forEach((f) => f(cache));
    return cache;
  }).catch(() => { pending = null; return cache; });
  return pending;
}

export function useStages() {
  const [s, setS] = useState(cache || { stages: STAGES, labels: STAGE_LABEL });
  useEffect(() => {
    subs.add(setS);
    if (cache) setS(cache); else if (!pending) refreshStages();
    return () => subs.delete(setS);
  }, []);
  return s;
}
